import { Component, Type } from '@angular/core';
import { Widget } from 'app/views/presentations/widgets/widget';
import { WidgetComponent } from 'app/views/presentations/widgets/widget.component';

export class EmptyWidget extends Widget {
    public type: string = 'Empty';
    public icon: string = 'fa-eraser';
    public nameResourceKey: string = 'modules.editors.nothing.name';
    public componentType: Type<WidgetComponent> = EmptyWidgetComponent;
}

@Component({
    selector: 'psm-empty-widget',
    templateUrl: 'empty.widget.html'
})
export class EmptyWidgetComponent extends WidgetComponent {
}



// WEBPACK FOOTER //
// ./src/app/views/presentations/widgets/empty/empty.widget.ts